"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationErrorType = exports.ErrorType = void 0;
const constants_1 = require("./common/constants");
var ErrorType;
(function (ErrorType) {
    ErrorType["INVALID_POST_MESSAGE_URL"] = "INVALID_POST_MESSAGE_URL";
    ErrorType["REQUEST_PATIENT_FAILED"] = "REQUEST_PATIENT_FAILED";
    ErrorType["NO_PATIENT_DATA_RECEIVED"] = "NO_PATIENT_DATA_RECEIVED";
    ErrorType["SENDING_BOOKING_DATA_ERROR"] = "SENDING_BOOKING_DATA_ERROR";
    ErrorType["SENDING_REFERRAL_DATA_ERROR"] = "SENDING_REFERRAL_DATA_ERROR";
    ErrorType["OTHER"] = "OTHER";
})(ErrorType = exports.ErrorType || (exports.ErrorType = {}));
var ValidationErrorType;
(function (ValidationErrorType) {
    ValidationErrorType["INVALID_PATIENT_DATA_BOOKING"] = "INVALID_PATIENT_DATA_BOOKING";
    ValidationErrorType["INVALID_PATIENT_DATA_REFERRAL"] = "INVALID_PATIENT_DATA_REFERRAL";
    ValidationErrorType["OTHER"] = "OTHER";
})(ValidationErrorType = exports.ValidationErrorType || (exports.ValidationErrorType = {}));
//# sourceMappingURL=types.js.map